export default __webpack_public_path__ + "static/media/613.42b78b77.png";